import React from 'react'
import styled from '@emotion/styled'
import { Colors, Levels, Shapes } from 'src/components/theme'
import { ErrorBoundary } from 'src/components/errors/error-boundary'
import { MapExplorerSearch } from 'src/views/map-explorer/sidebar/search'
import { MapExplorerPanels } from 'src/views/map-explorer/sidebar/panels'

const InsightSideBar = styled.div`
  height: 100%;
  position: relative;
  width: ${Shapes.sidebarWidth}px;
  display: flex;
  flex-direction: column;
  border-radius: 0px !important;
  border-right-width: 1px;
  box-shadow:
    20px 0px 24px -4px rgba(34, 37, 42, 0.08),
    8px 0px 8px -4px rgba(34, 37, 42, 0.03);
  z-index: ${Levels.sidebar};
`
const InsightSideBarContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: ${Colors.bgWhite};
  z-index: ${Levels.sidebarContent};
  overflow: hidden;
`

type MapExplorerSidebarProps = {
  footer?: React.ReactNode
}
export const MapExplorerSidebar = (props: MapExplorerSidebarProps) => {
  return (
    <InsightSideBar>
      <InsightSideBarContent>
        <MapExplorerSearch />
        <ErrorBoundary>
          <MapExplorerPanels />
          {props.footer}
        </ErrorBoundary>
      </InsightSideBarContent>
    </InsightSideBar>
  )
}
